import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../components/Modal';
import Input from '../../../components/Input';
import {Button, buttonTypes} from '../../../components/Button';
import {isEmailValid} from '../../../utils/validationUtils';

class ChangeEmail extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.changeUserEmail = this.changeUserEmail.bind(this);
    this.state = {
      checkPassword: '',
      newEmail: '',
      error: {}
    }
  }

  static propTypes = {
    isOpenModalChangeEmail: PropTypes.bool,
    toggleShowChangeEmailModal: PropTypes.func,
    changeUserEmail: PropTypes.func,
    currentEmail: PropTypes.string
  };

  componentWillReceiveProps(next) {
    this.setState({error: next.error})
  }

  handleChange(e) {
    this.setState({[e.target.name]: e.target.value})
  }

  changeUserEmail() {
    const {
      checkPassword,
      newEmail
    } = this.state;
    const err = {};
    if (!checkPassword) err.checkPassword = 'Add Password';
    if (!newEmail) err.newEmail = 'Add New Email';
    if (!isEmailValid(newEmail)) err.newEmail = 'Invalid Email';

    if (Object.keys(err).length === 0)
      this.props.changeUserEmail({password: checkPassword, newEmail});
    this.setState({error: err})
  }

  render() {
    const {
      isOpenModalChangeEmail,
      toggleShowChangeEmailModal,
      currentEmail,
    } = this.props;

    const {
      checkPassword,
      newEmail,
      error
    } = this.state;

    return (
      <Modal
        classModal="authentication"
        isOpen={isOpenModalChangeEmail}
        onRequestClose={toggleShowChangeEmailModal}
        showCloseIcon
        shouldCloseOnOverlayClick={false}
      >
        <div className="modal__wrap">
          <header>
            <h2 className="modal__title">Change E-mail</h2>
            <p className="modal__description">Fill all fields to change your e-mail</p>
          </header>
          <Input
            type="text"
            label="Current e-mail"
            placeholder="Current e-mail"
            value={currentEmail}
            name="currentEmail"
            error={error.currentEmail}
            onChange={() => {
            }}
          />
          <Input
            type="text"
            label="Your password"
            placeholder="Your password"
            value={checkPassword}
            name="checkPassword"
            error={error.checkPassword}
            onChange={this.handleChange}
          />
          <Input
            type="text"
            label="New e-mail"
            placeholder="New e-mail"
            value={newEmail}
            name="newEmail"
            error={error.newEmail}
            onChange={this.handleChange}
          />
          <Button
            type={buttonTypes.AUTHENTICATION}
            name="Change My E-mail"
            onClick={this.changeUserEmail}
          />
        </div>
      </Modal>
    )
  }
}

export default ChangeEmail;


// WEBPACK FOOTER //
// ./src/app/containers/Profile/components/ChangeEmailModal.js